import { authHeader, ApiConfigs } from '../_helpers';
import {userService} from "@/_services/user.service";

export const statisticsService = {
    getAll,
    filter,
    home,
    homeFilter,
    avgWatingService,
    visitFrequency,
    queueVisitFrequency,
    bookingVisitFrequency,
    serviceFrequency,
    customerStat,
    serviceDurations,
    serviceDurationsPerCounter,
    bookingPaymentStat,
    bookingPaymentAllTransactions,
    getTotalSms,
    getTotalBookings,
    getAvgWaitingTime,
    getAvgServiceTime,
    getHourPeak,
    getCounterPerformance,
    loadCounterServiceDuration,
    loadCounterFeedback,
    getTotalTickets,
    getTotalServices
};

function bookingPaymentAllTransactions(data){
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.bookingPaymentAllTransactions}`, requestOptions).then(handleResponse);
}

function loadCounterFeedback(data){
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.counterFeedbackStatistics}`, requestOptions).then(handleResponse);
}
function loadCounterServiceDuration(data){
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.counterServiceDuration}`, requestOptions).then(handleResponse);
}
function getTotalTickets(data){
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.totalTickets}`, requestOptions).then(handleResponse);
}
function getTotalServices(data){
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.totalServices}`, requestOptions).then(handleResponse);
}
function getTotalSms(data){
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.totalSms}`, requestOptions).then(handleResponse);
}

function getTotalBookings(data){
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.totalBookings}`, requestOptions).then(handleResponse);
}

function getAvgWaitingTime(data){
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.avgWaitingTime}`, requestOptions).then(handleResponse);
}

function getAvgServiceTime(data){
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.avgServiceTime}`, requestOptions).then(handleResponse);
}

function getHourPeak(data){
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.hourPeak}`, requestOptions).then(handleResponse);
}
function getCounterPerformance(data){
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.counterPerformance}`, requestOptions).then(handleResponse);
}
function bookingPaymentStat(data){
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.bookingPaymentStat}`, requestOptions).then(handleResponse);
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.getAll}`, requestOptions).then(handleResponse);
}


function home() {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.home}`, requestOptions).then(handleResponse);
}



function filter(data) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.filter}`, requestOptions).then(handleResponse);
}


function homeFilter(data) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.home_filter}`, requestOptions).then(handleResponse);
}

function avgWatingService(data) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.avgWatingService}`, requestOptions).then(handleResponse);
}

function visitFrequency(data) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.visitFrequency}`, requestOptions).then(handleResponse);
}
function queueVisitFrequency(data) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.queueVisitFrequency}`, requestOptions).then(handleResponse);
}
function bookingVisitFrequency(data) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.bookingVisitFrequency}`, requestOptions).then(handleResponse);
}
function serviceFrequency(data) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.serviceFrequency}`, requestOptions).then(handleResponse);
}

function serviceDurations(data) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.serviceDurations}`, requestOptions).then(handleResponse);
}

function serviceDurationsPerCounter(data) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.serviceDurationsPerCounter}`, requestOptions).then(handleResponse);
}

function customerStat(data) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.statistics.customerStat}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401 || response.status === 403) {

                // auto logout if 401 response returned from api
                if(localStorage.getItem('user')){
                    userService.logout();
                }
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}